import React, { useState, useEffect, useContext } from "react";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import EditCompanyInfo from "./EditCompanyInfo";
import { FormGroup, Label, Input } from "reactstrap";
import "./prospectingDetailsPage.scss";
import Service from "../../services";
import ToolTip from "../../utils/ToolTip";
import RoleAuthorization from "../Authentication/RoleAuthorization";
import { Pages, actionAuthorization } from "../../utils/RolesUtil";
import { TriggerContext } from "../../Context/TriggerContext";
interface CardInfoProps {
  title: string;
  isEditable?: boolean;
  cols: Array<any>;
  data: any;
  isAddLable: boolean;
  toggleEditCompanyModal?: any;
  getLeadData?: any;
  addLabel?: any;
  clientId?: string;
  removeLabel?: any;
  trackerName?: string;
}

function CardInfo(props: CardInfoProps) {
  const [show, setShow] = useState(false);
  const service = new Service();
  const [selectedLabel, setSelectedLabel] = useState("false");

  const selectLabel = () => setShow((pre) => !pre);

  const clientContext = useContext(TriggerContext);

  const data = [
    {
      id: "CBD",
      name: "CBD",
    },
    {
      id: "CBD",
      name: "CBD",
    },
    {
      id: "CBD",
      name: "CBD",
    },
  ];


  const onSelectLabel = (e: any) => {
    setSelectedLabel(e.target.value);
  };

  const removeLabel = (label: any) => {
    props.removeLabel(label);
  };

  useEffect(() => { }, [])

  const TooltipWrapper = (content: string = '') => {
    return (
      <div className="lable tooltip-container">
        <span className="title">
          {content.length > 20 ? content.substring(0, 20) + "..." : content}
        </span>

        {content.length > 20 && (
          <span className="tooltiptext">{content}</span>
        )}
      </div>
    );
  };

  return (
    <Card className="detailspage-cardinfo">
      <CardHeader>
        <Row className="cradinfo-header">
          <Col className="card-tittle"> {props.title}</Col>
          {props.isEditable ? (
            <>
              <Col>
                {" "}
                {RoleAuthorization(Pages.customerDetailsPage, actionAuthorization.editCompanyInfo) &&
                  !clientContext?.readOnlyMode &&
                  <EditCompanyInfo
                    data={props.data}
                    getLeadData={props?.getLeadData}
                    clientId={props.clientId}
                    trackerName={props?.trackerName}
                  />}
              </Col>
            </>
          ) : props.isAddLable ? (
            <Col onClick={selectLabel} className="edit-lable">
              Add Label
            </Col>
          ) : (
            " "
          )}
        </Row>
      </CardHeader>
      <CardBody>
        {props.cols?.map((row: any) => (
          <Row>
            {row.map((col: any, index: number) => (
              <Col md={6} style={col.name === "industryType" || col.name === "title" ? { marginTop: "-30px" } : {}}>
                <div className="lable">{col.label}</div>
                <div
                  id={"content-" + col.name + "-" + index}
                  className="lableContent"
                >
                  {Array.isArray(props.data[col.name])
                    ? props.data[col.name]?.length
                      ? props.data[col.name].map((ad: any) => <div>{ad}</div>)
                      : ""
                    : TooltipWrapper(props.data[col.name] || "- -")}
                </div>



              </Col>
            ))}
          </Row>
        ))}

      </CardBody>
    </Card>
  );
}

export default CardInfo;
